export * from './card-details.tsx'
